import { HTMLAttributes, ReactNode, useRef } from 'react'
import { cn } from '@dashboard/ui'
import { Handle, Position } from 'reactflow'

export interface ShadowHoverBlockProps extends HTMLAttributes<HTMLDivElement> {
  color: string
  selected?: boolean
  hasNext: boolean
  disabledOutput?: boolean
  children?: ReactNode
}

export const ShadowHoverBlock = ({
  disabledOutput,
  selected,
  color,
  className,
  hasNext,
  children,
}: ShadowHoverBlockProps) => {
  const ref = useRef<HTMLDivElement>(null)
  return (
    <div
      ref={ref}
      style={{
        borderColor: color,
        boxShadow: selected ? `1px 4px 22px 0px ${color}` : '',
      }}
      onMouseOver={() => {
        if (ref.current) {
          ref.current.style.boxShadow = `1px 4px 22px 0px ${color}`
          if (ref.current.lastChild) {
            ;(ref.current.lastChild as HTMLDivElement).style.boxShadow = `1px 4px 22px 0px ${color}`
          }
        }
      }}
      onMouseOut={() => {
        if (selected) {
          return
        }
        if (ref.current) {
          ref.current.style.boxShadow = ''
          if (ref.current.lastChild) {
            ;(ref.current.lastChild as HTMLDivElement).style.boxShadow = ''
          }
        }
      }}
      className={cn(
        `relative flex size-[68px] cursor-pointer items-center justify-center rounded-md border-2 bg-fg-primary p-3.5`,
        className,
      )}
    >
      <div
        style={{
          border: `2px solid #68C9E7`,
        }}
        className="absolute top-[-8px] z-[-1] size-[16px] rounded-full bg-fg-primary"
      />
      <Handle
        type={'target'}
        id={'input'}
        position={Position.Top}
        className="absolute left-1/2 top-[-8px] z-10 h-full w-[70px] rounded-none opacity-0"
        isConnectable={true}
      />
      {!disabledOutput && (
        <Handle
          type={'source'}
          id={'output'}
          position={Position.Bottom}
          isConnectable={true}
          style={{
            transform: 'translate(-50%, 5px)',
            borderRadius: '100%',
            border: `2px solid #68C9E7`,
            bottom: hasNext ? '' : '-106px',
            zIndex: hasNext ? -1 : 1,
          }}
          className="size-[16px] bg-fg-primary"
        />
      )}
      {children}
    </div>
  )
}
